// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"50f5f750","39":"46cf2b93","40":"c7fb5fcd","79":"efb49299","129":"981a273b","162":"56ab12f7","274":"fd924d05","435":"7b5bcfdf","841":"17089e56","872":"0b3b6e4b"}[chunkId] + ".chunk.js";
};